import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import {oneOf} from 'shared/store';
import {Segment} from 'main/stores/segmentation';

class SegmentCalendar extends DomainObject {
  name;
  description;
  locale;
  calendarType;
  participantSegment;
  subscriptionSegment;

  _relations = {
    participantSegment: Segment,
    subscriptionSegment: Segment,
    locale: oneOf(['en', 'fr']),
    calendarType: oneOf(['pto', 'birthdays', 'work_anniversaries'])
  };

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable,
      description: observable,
      locale: observable,
      calendarType: observable,
      participantSegment: observable,
      subscriptionSegment: observable
    });

    this.merge(other);
  }
}

export default SegmentCalendar;
